<div class="user-section d-flex flex-column">
  <div class="user-info d-flex flex-row justify-content-between">
    <div class="d-flex flex-column align-items-start">
      <!-- User Name -->
      <div class="user-name" data-test-id="user-name">
        {{ userName() }}
      </div>

      <!-- User Branch -->
      <div class="user-branch d-flex flex-row" data-test-id="user-branch">
        <span>Branch #{{ branches()[0] }}</span>
        @if (branches().length > 1) {
          <span class="counter">
            (+{{ branches().length - 1 }})
          </span>
        }
      </div>

      <!-- User Role -->
      <div class="user-role d-flex flex-row" data-test-id="user-role">
        <span class="text">{{ roles()[0] }}</span>
        @if (roles().length > 1) {
          <span class="counter" [pTooltip]="roles().join(', ')" tooltipPosition="top">
            (+{{ roles().length - 1 }})
          </span>
        }
      </div>

      <!-- GHR Title -->
      @if (ghrTitle()) {
        <div class="user-ghr-title" data-test-id="user-ghr-title">
          {{ ghrTitle() }}
        </div>
      }

      <!-- Role Mismatch Warning -->
      @if (roleMismatch()) {
        <div
          class="role-mismatch-warning d-flex flex-row align-items-center"
          [pTooltip]="mismatchWarnings()[0]"
          tooltipPosition="right"
          data-test-id="role-mismatch-warning"
        >
          <i class="pi pi-exclamation-triangle me-1"></i>
          <span>Role mismatch</span>
        </div>
      }
    </div>

    <!-- Settings -->
    <div class="d-flex justify-content-center align-items-center ms-3">
      <a class="settings-link" routerLink="/settings" pTooltip="Open Settings" tooltipPosition="top">
        <i class="pi pi-cog icon"></i>
      </a>
    </div>
  </div>

  <!-- Logout -->
  <button (click)="logout()" class="button-primary-black small mt-2" data-test-id="logout-button">
    Logout
  </button>
</div>
